import { businessRequest, commonInitProduct, commonInitProductV2, commonInitProductV3, getCommonPageConfig, getCommonPageBatchConfig, getCommonShareConfig, getCommonShareConfigV2, getCommonShareBatchConfig, getCommonShareBatchConfigV2, getCommonCoverConfig, getCommonXaidConfig, commonUpdateWebxUserInfo, getCommonLaunchAppConfigV2, trackCommonLaunchAppEvent, upCommonLaunchAppEvent } from '@didi/webx-js-core';
import { query, hashQuery } from '../query';
import { getBranch } from '../initSDK';
import { post, request } from '../request/index';
import { getNineChapterWebxParams, getRuntimeStandardArgument } from '../statistic';
import { getInitialStorage, storage } from '../storage';
import { initShare } from '../webxShare';
/* 同域请求域名白名单 */
const allowedList = ['https://page.udache.com', 'https://prod.didi.cn'];
/**
 * 判断是否要使用同域请求
 */
export function isSameDomain(config) {
    if (!config) {
        config = { sameOrigin: true };
    }
    const isSame = allowedList.includes(window.location.origin) && (config.sameOrigin || config === 'online');
    if ((config.sameOrigin || config === 'online') && !isSame) {
        console.log('%c 当前域名未在白名单内，同源请求未生效 %c', 'background-color: #d4c39e; color: #333333; padding: 0 0 0 8px; border-radius: 2px', 'color: #d4c39e; font-size: 12px; padding: 0 8px;');
    }
    return isSame;
}
/**
 * 获取api前缀
 * @param config
 * @returns
 */
export function getApiPerfix(config) {
    // 判断是否同域，不同域的话，沿用老逻辑getHostBranch获取域名 后续要去掉online，所以只在调用getHostBranch时给到默认值online 其他地方都传空
    return isSameDomain(config) ? `${window.location.origin}/serv` : '';
}
function getHostBranch() {
    let branch = getBranch();
    let exhaustiveCheck;
    switch (branch) {
        case 'kfpassenger':
        case 'kfdriver':
            return 'kf';
        case 'passenger':
        case 'driver':
            return 'didi';
        default:
            exhaustiveCheck = branch; // eslint-disable-line
            return 'didi';
    }
}
const getSessionParams = () => {
    let params = Object.assign({}, query(), hashQuery());
    return {
        root_xpsid: params.root_xpsid,
        f_xpsid: params.f_xpsid
    };
};
const getSessionParamsV2 = () => {
    const params = Object.assign({}, query(), hashQuery());
    return {
        x_act_key: params.x_act_key,
        root_xpsid: params.root_xpsid,
        f_xpsid: params.f_xpsid
    };
};
const setNineChapterParams = (data) => {
    const nineChapterParamsKey = [
        'dchn',
        'prod_key',
        'xbiz',
        'xpsid',
        'xoid',
        'xspm_from',
        'xpsid_from',
        'xpsid_root',
        'xpsid_share',
        'xpos_from'
    ];
    nineChapterParamsKey.forEach((key) => {
        if (key === 'xpos_from' && data['xpos_from'])
            storage.webxNineChapterParams[key] = encodeURIComponent(JSON.stringify(data['xpos_from']));
        else if (data[key])
            storage.webxNineChapterParams[key] = data[key];
    });
};
const _initProduct = async (version, config, option, extra) => {
    // 根据传入的version版本调用不同的底层API
    const commonInitProductFn = {
        v1: commonInitProduct,
        v2: commonInitProductV2,
        v3: commonInitProductV3,
    };
    const initFn = commonInitProductFn[version];
    const sessionParams = version === 'v1' ? getSessionParams() : getSessionParamsV2();
    const { cb } = extra || {};
    return initFn(config, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams({
        useStorage: false,
        extParams: {
            xpos_share: true,
            xpsid_share: true
        }
    }), sessionParams, getHostBranch(), getClusterId(), post).then((data) => {
        setNineChapterParams(data);
        cb && cb(data);
        return data;
    });
};
const initProduct = (config, option) => {
    return _initProduct('v1', config, option);
};
const initProductV2 = (config, option) => {
    return _initProduct('v2', config, option);
};
const initProductV3 = async (config, option) => {
    const { token } = config?.args?.runtime_args || {};
    const passportTypeConfig = {
        'passenger': 'wyc',
        'driver': 'wyc',
        'kfpassenger': 'kf',
        'kfdriver': 'kf'
    };
    // 定制化入参
    const params = {
        token,
        ...config,
        passport_type: passportTypeConfig[getBranch()],
    };
    // 回调函数
    const cb = (res) => {
        try {
            /** 判定模版中是否有分享数据 */
            const hasSSRStorageShare = Object.keys(getInitialStorage()?.shareConf || {}).length > 0;
            /** 满足以下判定为SSR：模版上有分享数据 && 不需要分享 && 不需要页面内容 */
            const isSSRInitWebx = hasSSRStorageShare && !config?.need_share_config && !config?.need_page_config;
            /** 可以进行initShare的条件：是SSR初始化webx || (CSR情况下有响应体 且 需要分享) */
            const isCanInitShare = isSSRInitWebx || (res.conf && config?.need_share_config);
            if (isCanInitShare) {
                initShare(res, isSSRInitWebx);
            }
        }
        catch (e) {
            console.log(e);
        }
    };
    return _initProduct('v3', params, option, { cb });
};
const businessInit = async (options) => {
    return businessRequest(options, request).then((data) => {
        return data;
    });
};
const getPageConfig = (payload, option) => {
    /* 2021-11-16 新增 根据config.args的类型 判断是否需要批量获取 */
    if (payload.args &&
        Object.prototype.toString.call(payload.args) === '[object Array]') {
        return getCommonPageBatchConfig(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParams(), getHostBranch(), query().preview === 'true', getClusterId(), post);
    }
    else {
        return getCommonPageConfig(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParams(), getHostBranch(), query().preview === 'true', getClusterId(), post);
    }
};
const getShareConfig = (payload, option) => {
    /* 2021-11-16 新增 根据config.args的类型 判断是否需要批量获取 */
    if (payload.args &&
        Object.prototype.toString.call(payload.args) === '[object Array]') {
        return getCommonShareBatchConfig(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
    }
    else {
        return getCommonShareConfig(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
    }
};
const getShareConfigV2 = async (payload, option) => {
    /* 2021-11-16 新增 根据config.args的类型 判断是否需要批量获取 */
    if (payload.args &&
        Object.prototype.toString.call(payload.args) === '[object Array]') {
        return getCommonShareBatchConfigV2(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
    }
    else {
        return getCommonShareConfigV2(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParamsV2(), getHostBranch(), getClusterId(), post);
    }
};
const getCoverConfig = (payload, option) => {
    return getCommonCoverConfig(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
};
const getXaidConfig = (payload, option) => {
    return getCommonXaidConfig(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
};
const updateWebxUserInfo = (payload, option) => {
    return commonUpdateWebxUserInfo(payload, getApiPerfix(option), getRuntimeStandardArgument(), getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
};
const getLaunchAppConfigV2 = (payload, option) => {
    return getCommonLaunchAppConfigV2(payload, getApiPerfix(option), getHostBranch(), getClusterId(), post);
};
const trackLaunchAppEvent = (payload, option) => {
    return trackCommonLaunchAppEvent(payload, getApiPerfix(option), getHostBranch(), getClusterId(), post);
};
const upLaunchAppEvent = (payload, option) => {
    return upCommonLaunchAppEvent(payload, getApiPerfix(option), getHostBranch(), getClusterId(), post);
};
const getClusterId = () => {
    return Number(query().webx_cluster_id) || 1000;
};
// const getClusterId: IgetClusterId = async (xpsid_root = '') => {
//   if (clusterDict[xpsid_root]) return clusterDict[xpsid_root]
//   if (!crypto.subtle) return 1000
//   const encoder = new TextEncoder()
//   const buffer = encoder.encode(xpsid_root)
//   console.time('crypto.subtle.digest')
//   const hash = await crypto.subtle.digest('SHA-256', buffer)
//   console.timeEnd('crypto.subtle.digest')
//   const bytes = new Uint8Array(hash, 0, 4)
//   bytes.reverse()
//   const int1 = bytes[0]
//   const int2 = bytes[1] << 8
//   const int3 = bytes[2] << 16
//   const int4 = bytes[3] << 24
//   const num = int4 | int3 | int2 | int1
//   const result = Math.abs(num % 1000)
//   clusterDict[xpsid_root] = result
//   return result
// }
export { initProduct, initProductV2, initProductV3, getPageConfig, getShareConfig, getShareConfigV2, getCoverConfig, getXaidConfig, updateWebxUserInfo, getSessionParams, 
// getLaunchAppConfig,
getLaunchAppConfigV2, 
// getLaunchAppStatus,
trackLaunchAppEvent, upLaunchAppEvent, businessInit };
